import React from 'react'
import Name from '@/components/Name'
import getEnumTranslation from '@/enums/enums'
import { useLocalization } from '@/hooks/localization'
import { reportSubmissionGroupExportType } from '@/enums/reportSubmissionGroupExportType'

const ReportSubmissionGroupDetails = ({ data, locale }) => {
  const { localize } = useLocalization()
  const { enumName } = reportSubmissionGroupExportType
  return <div>
    {data && (data.reportGroupSubmissionName || data.reportGroupSubmissionLatinName) && <small><Name data={{ name: data.reportGroupSubmissionName, latinName: data.reportGroupSubmissionLatinName }} /></small>}
    {data && typeof data.exportType === 'number' && <small>, {getEnumTranslation({ localize, enumName, value: data.exportType })}</small>}
  </div>
}

export {
  ReportSubmissionGroupDetails
}



// WEBPACK FOOTER //
// ./src/components/backgroundJobs/reportSubmissionGroupDetails.js